import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { ApiError } from "@/api";
import { ChatsListPage } from "@/features/chat/history/ChatsListPage";
import { NotFoundPage } from "@/features/errors/NotFoundPage";
import { useSpaceHub } from "./useSpaceHub";

/** `/spaces/:spaceUuid/chats`: the chat history list, limited to this space. */
export function SpaceChatsPage() {
  const { t } = useTranslation("spaces", { keyPrefix: "detail" });
  const { spaceUuid = "" } = useParams();
  const hub = useSpaceHub(spaceUuid);
  if (hub.error instanceof ApiError && (hub.error.status === 404 || hub.error.status === 403)) {
    return <NotFoundPage />;
  }
  const name = hub.data?.name ?? "";
  return (
    <ChatsListPage space={{ uuid: spaceUuid, name, title: t("chatsTitle"), subtitle: t("chatsSubtitle", { name }) }} />
  );
}
